import React, { useState } from 'react';
import { Typography, Grid, Button } from '@mui/material';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import { Box } from '@mui/system';
import CreatePerksModal from 'src/components/Perks/CreatePerksModal';

interface PerksHeaderProps {
  refreshPerks: () => void;
}
const PerksHeader:React.FC<PerksHeaderProps> = ({refreshPerks}) => {
  const [open, setOpen] = useState(false);
  function onClose() {
    setOpen(false);
  }
  return (
    <Box>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <Typography variant="h3" component="h3" gutterBottom>
            Perks
          </Typography>
          <Typography variant="subtitle2">
            Welcome to the perks section
          </Typography>
        </Grid>
        <Grid
          item
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            width: { xs: '100%', sm: 'auto' },
            minWidth: { sm: 400 },
            gap: 2,
            mt: { sm: 2 }
          }}
        >
          <Button
            sx={{
              mt: { xs: 2, md: 0 }
            }}
            variant="contained"
            startIcon={<AddTwoToneIcon fontSize="small" />}
            onClick={() => setOpen(true)}
          >
            Create New Perk
          </Button>
        </Grid>
      </Grid>
      <CreatePerksModal refreshPerks={refreshPerks} open={open} onClose={onClose} />
    </Box>
  );
};

export default PerksHeader;
